<div class="input-shell">
  <textarea class="chat-textarea ng-untouched ng-pristine ng-valid" rows="1"
    placeholder="Ask about your Policy related queries…"></textarea>
  <button>
    <i class="pi pi-send"></i>
  </button>
  <app-agent-voice-input>
    <button>
      <i class="pi pi-microphone"></i>
    </button>
  </app-agent-voice-input>
</div>
<p class="input-hint">
  <i class="pi pi-info-circle"></i>Press <kbd>Enter</kbd> to send - <kbd>Shift+Enter</kbd> for new line
</p>
